<smrts-dialog [title]="title" [hasFootnote]="true" fixedHeight="820px">

  <app-cadastro-lote [tiposLancamento]="tiposLancamento" (loteEncontrado)="onLoteEncontrado()"></app-cadastro-lote>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button [disableNoPermission]="permissaoEditarLancamento" (click)="salvarClick()">
      Salvar
    </button>
  </div>

</smrts-dialog>
